import { render, staticRenderFns } from "./ProductScopedIndex.vue?vue&type=template&id=df414f70"
import script from "./ProductScopedIndex.vue?vue&type=script&lang=js"
export * from "./ProductScopedIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports